import { app } from '../../app';
import { Controller } from './sp-license-info.controller';

app.component('spLicenseInfo', {
    bindings: {
        licenseInfo: '<',
    },
    controller: Controller,
    templateUrl: require('./sp-license-info.html'),
});



// WEBPACK FOOTER //
// ./src/portal/components/sp-license-info/sp-license-info.component.js